import { PermissaoUsuarioDTO } from "types/permissoes/PermissaoUsuario";
import { TipoPermissao } from "./EnumTipoPermissao";

export const permissoes = new Map<string, PermissaoUsuarioDTO>([
  ["1", { id: "1", nome: TipoPermissao.VISUALIZAR }],
  ["2", { id: "2", nome: TipoPermissao.INCLUIR }],
  ["3", { id: "3", nome: TipoPermissao.ALTERAR }],
  ["4", { id: "4", nome: TipoPermissao.EXCLUIR }],
  ["5", { id: "5", nome: TipoPermissao.EXECUTAR }],
]);
